<template>
  <div class="publication col col-12 md-col-4 lg-col-3 p2">
    <router-link
      :to="{ name: 'Publication', params: { slug: content.slug }}">
      <div class="col-12 flex items-end">
        <div class="center col-12 mb3">
          <img class="thumbnail mx-auto" :src="cover" />
          <h3 class="red fs-s my1" v-text="publication.acf.year" />
          <h2 class="caps center col-12 md-col-10 mx-auto my1">
            <span v-html="preventWidows(content.title.rendered)" />
            <span class="red fs-s ml1" v-if="content.acf.language && content.acf.language !== 'EN'" v-text="content.acf.language" />
          </h2>
          <em v-text="flattenArray(content.acf.author)" />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import {formatDate} from '../utils'
import CardBlock from '@/components/CardBlock'

export default {

  name: 'PublicationPreview',

  data () {
    return {

    }
  },

  props: ['content'],

  components: {
    CardBlock
  },

  methods: {
    formatDate
  },

  computed: {
    cover () {
      if (this.content.acf.cover_image) {
        return this.content.acf.cover_image.sizes['large']
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .publication {
    &:nth-child(4n) {
      border-right: none;
    }
    .header {
      height: 2em;
    }
    .thumbnail {
      height: 32vw;
      margin: 0 auto;
    }
  }
</style>
